import styled from "styled-components";

const PlayButton = styled.button`
    font-size: 2em;
    background: rgb(234, 146, 19);
    background: linear-gradient(
        0deg,
        rgba(234, 146, 19, 1) 0%,
        rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    color: #fff;
    user-select: none;
    padding: 0.25em 2.5em;
    margin: 1em 0;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin: 0;
    }
`;

export default PlayButton;
